module.exports = __webpack_public_path__ + "images/cavallo-d012c496b54ecaccbf286a79e64f3708.jpg";